module.exports = __webpack_public_path__ + "static/media/sign-language.c95f544b.svg";